import { useSeriesListYearsQuery } from '~/pages/series/queries';
import { filterSchema } from './divisions-list-filter.schema';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Table } from '~/components/Table/Table';
import { Grid } from '~/components/Grid/Grid';
import { Input } from '~/components/Input';

export function DivisionListFilter() {
  const { register, setValue, values } = useFilterForm(filterSchema.parse);
  const { data } = useSeriesListYearsQuery();

  return (
    <div
      style={{
        borderBottom: '2px solid var(--color-fg-secondary)',
        paddingBottom: 'var(--size-4)',
        marginBottom: 'var(--size-4)',
      }}
    >
      <Grid>
        <Grid.Item cols={{ sm: 6, md: 4 }}>
          <Table.Search {...register('search')} placeholder="Sök på serie..." />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 3 }}>
          <Input.Select
            aria-label="År"
            options={(data?.years ?? []).map(y => [String(y), y])}
            defaultValue={values.year}
            onChange={e => setValue('year', e.target.value)}
          />
        </Grid.Item>
      </Grid>
    </div>
  );
}
